// @flow

export default (props) => {
  switch ( props.decorator || props.is ) {
    case 'ProductListSlider':
      return import('fg-frontend/components/ProductListSlider');
    case 'EshopPhotogallery':
      return import('fg-frontend/components/EshopPhotogallery');
    case 'EshopModel3D':
      return import('fg-frontend/components/EshopModel3D');
    case 'EshopImageMagnify':
      return import('fg-frontend/components/EshopImageMagnify');
    case 'EshopGalleryPopup':
      return import('./components/EshopGalleryPopup');
    case 'EshopOrderForm':
      return import('fg-frontend/components/EshopOrderForm');
    case 'EshopFulltextAutocomplete':
      //ESHOP: fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
      return import('fg-frontend/src/components/EshopFulltextAutocomplete');
    case 'EshopUserToolsHandler':
      // ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani (odeberte, pokud na projektu nepouzivate ani oblibene ani porovnavani)
      return import('./components/EshopUserToolsHandler');
    case 'GlobalFilter':
      return import('./components/GlobalFilter');
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js